import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-account-owner',
  templateUrl: './account-owner.component.html',
  providers: [NgxSpinnerService]
})
export class AccountOwnerComponent implements OnInit {

  constructor(
    private translate: TranslateService, 
    private functionsService: FunctionsService,
    private router: Router) {
    this.translate.addLangs(['en', 'es']);
    if (localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      translate.use(browserLang.match(/en|es/) ? browserLang : 'en');
    } else { 
      localStorage.setItem('locale', 'en');
      translate.setDefaultLang('en');
    }
    if(this.functionsService.getRole()!="Owner"){
      this.router.navigateByUrl('/');
    }
  }

  ngOnInit() {
  }
}